import { ChangeDetectionStrategy, Component, model, input, ViewEncapsulation, computed } from '@angular/core';
import {
    IOnboardingReportAvailableItems,
    IOnboardingReportWidget,
    IOnboardingReportWidgetFilter,
} from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report';
import {
    FiOnboardingReportType,
    FiOnboardingReportWidgetType,
} from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report-enums';
import { Subject } from 'rxjs';

@Component({
    selector: 'fi-onboarding-report-new-widget-filter-settings-content',
    templateUrl: './fi-new-widget-filter-settings-content.component.html',
    styleUrls: ['./fi-new-widget-filter-settings-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-new-widget-filter-settings-content' },
    standalone: false,
})
export class FiOnbaordingReportNewWidgetFilterSettingsContentComponent {
    public widget = input.required<IOnboardingReportWidget>();
    public currentFilter = model.required<IOnboardingReportWidgetFilter>();
    public reportWidgetType = input.required<FiOnboardingReportWidgetType>();
    public reportType = input.required<FiOnboardingReportType>();
    public availableItems = input.required<IOnboardingReportAvailableItems>();
    public isFilterApplied = input.required<boolean>();

    protected selectedFilterItemsChanged$ = new Subject<void>();

    protected filterChanged(newFilter: IOnboardingReportWidgetFilter): void {
        this.currentFilter.set({ ...newFilter });
        this.selectedFilterItemsChanged$.next();
    }

    protected resetCurrentFilter(): void {
        this.currentFilter.set({});
        this.selectedFilterItemsChanged$.next();
    }

    protected FiOnboardingReportWidgetType = FiOnboardingReportWidgetType;
}
